import Swiper from 'swiper';

let swiper_main = new Swiper('.js-main-slider', {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.js-main-slider .swiper-nav__next',
    prevEl: '.js-main-slider .swiper-nav__prev',
  },
});

let swiper_offer = new Swiper('.js-offer-swiper', {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.js-offer-swiper .swiper-nav__next',
    prevEl: '.js-offer-swiper .swiper-nav__prev',
  },
})

let realisation_swiper = new Swiper('.js-realisation-swiper', {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  allowTouchMove: false,
});



const realisationSwiperChangeHandler = (clickedItem, index) => {
  let parent = clickedItem.parentNode;

  let childrenArray = [...document.querySelectorAll('.js-realisation-list')]

  childrenArray.forEach(child => {
    child.classList.remove('is-active');
  })
  clickedItem.classList.add('is-active');

  if (window.innerWidth < 1200) {
    var element = document.querySelector('#realizacje');
    var topPos = element.getBoundingClientRect().top + window.scrollY;
    scrollIt(topPos - 60, 300, 'easeOutQuad', () => console.log(`Just finished scrolling to ${window.pageYOffset}px`));
  }
  realisation_swiper.slideTo(index);
}

//! FIXERS
function updateSwiper(swiper) {
  setTimeout(function () {
    swiper.update();
  }, 500);
}


if(document.querySelector('.js-fleet-container')){
  updateSwiper(swiper_main);
  window.onresize = function(event){
    updateSwiper(swiper_main);
  }
}

function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}



const fleetSwiperChangeHandler = (clickedItem, index) => {
  let parent = clickedItem.parentNode;

  let childrenArray = [...parent.children];

  childrenArray.forEach(child => {
    child.classList.remove('is-active');
  })
  clickedItem.classList.add('is-active');

  if (window.innerWidth < 767) {
    scrollIt(document.querySelector('#flota').offsetTop + 900, 300, 'easeOutQuad', () => console.log(`Just finished scrolling to ${window.pageYOffset}px`));
  }
  swiper_main.slideTo(index);
}

export {
  realisationSwiperChangeHandler,
  fleetSwiperChangeHandler
}
